<template>
  <account-modal class="wallet-type-modal">
    <template slot="heading">Wallet type</template>

    <template slot="content">
      <v-layout
        class="subheading"
      >
        <v-flex xs12>
          <one-data-column>
            <data-label slot="label">Type</data-label>
            <div class="t-type">{{ integratorType }}</div>
          </one-data-column>

          <template v-if="webhook">
            <one-data-column>
              <data-label slot="label">ID</data-label>
              <div class="t-id">{{ webhook.id }}</div>
            </one-data-column>

            <one-data-column>
              <data-label slot="label">Wallet ID</data-label>
              <div class="t-wallet-id">{{ webhook.walletId }}</div>
            </one-data-column>

            <one-data-column>
              <data-label slot="label">Public Key</data-label>
              <div style="display: flex">
                <code style="word-break: break-word; white-space: pre-line;">{{ webhook.publicKey }}</code>
                <div>
                  <div class="mb-2">
                    <copy-button :value="webhook.publicKey" />
                  </div>
                </div>
              </div>
            </one-data-column>

            <one-data-column>
              <data-label slot="label">Active</data-label>
              <div class="t-active">{{ webhook.active }}</div>
            </one-data-column>

            <one-data-column>
              <data-label slot="label">Date created</data-label>
              <div class="t-created-at">{{ webhook.createdAt | date }}</div>
            </one-data-column>
          </template>
        </v-flex>
      </v-layout>

      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        class="t-delete-button"
        color="light-blue darken-3"
        :disabled="loading"
        flat
        @click="onDeleteButtonClick"
      >delete</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >close</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_UPDATE } from '@/events/accounts'

  // Services
  import IntegratorsApi from '@/services/Api/IntegratorsApi'

  // Mixins
  import modal from '@/mixins/modal'
  import flashMessages from '@/mixins/flashMessages'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import OneDataColumn from '@/components/ui/Data/OneDataColumn'
  import DataLabel from '@/components/ui/Data/DataLabel'
  import CopyButton from '@/components/ui-v2/Buttons/CopyButton'

  export default {
    name: 'WalletTypeModal',
    components: {
      AccountModal,
      ErrorAlert,
      OneDataColumn,
      DataLabel,
      CopyButton
    },
    mixins: [modal, flashMessages],
    data () {
      return {
        removeIntegratorApiRequest: new ApiRequest(IntegratorsApi.deleteWalletIntegrator)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      accountId () {
        return this.modal.data.account.accountId
      },
      profileId () {
        return this.modal.data.profileId
      },
      integratorType () {
        return this.modal.data.walletIntegrator.type
      },
      webhook () {
        return this.modal.data.walletIntegrator.webhook
      },
      loading () {
        return this.removeIntegratorApiRequest.loading
      },
      error () {
        return this.removeIntegratorApiRequest.error
      }
    },
    methods: {
      onDeleteButtonClick () {
        this.removeIntegratorApiRequest
          .execute(this.accountId)
          .then(() => {
            this.$eventHub.$emit(EVENT_ACCOUNT_UPDATE, this.profileId)

            this.showSuccessFlashMessage('Account has been successfully edited.')
          })
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      }
    }
  }
</script>

<style lang="scss">
.wallet-type-modal {
  &__public-key {
    font-size: 13px;
    padding: 10px;

    &::before, &::after {
      content: none;
    }
  }
}
</style>
